import { render } from "./Collection_Bulk_Upload.vue?vue&type=template&id=4898b4f6&scoped=true"
import script from "./Collection_Bulk_Upload.vue?vue&type=script&lang=js"
export * from "./Collection_Bulk_Upload.vue?vue&type=script&lang=js"

import "./Collection_Bulk_Upload.vue?vue&type=style&index=0&id=4898b4f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4898b4f6"]])

export default __exports__